<template>
  <md-menu class="icon-select" md-align-trigger>
    <div class="icon-container" md-menu-trigger>
      <md-icon class="selected-icon" :md-src="iconSvgMap[selectedKey]" />
      <md-icon v-once class="md-icon-image">
        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 10l5 5 5-5z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </md-icon>
    </div>

    <md-menu-content class="icon-dropdown">
      <img
        v-for="key in Object.keys(customMenuIcons)"
        :key="key"
        class="icon-img"
        :class="{ selected: key === selectedKey }"
        :src="iconSvgMap[key]"
        @click="selectIcon(key)"
      >
    </md-menu-content>
  </md-menu>
</template>

<script>
import customMenuIcons from '~lib/common/config/customMenuIcons';
const iconSvgMap = Object.entries(customMenuIcons).reduce((accum, [key, value]) => {
  accum[key] = require(`../../assets/custom-menu-icons/${value.svgName}`);
  return accum;
}, {});

export default {
  name: 'icon-select',
  props: {
    selectedKey: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      customMenuIcons,
      iconSvgMap,
    };
  },
  methods: {
    selectIcon(value) {
      this.$emit('update', value);
    }
  }
}
</script>

<style scoped>
.icon-select {
  cursor: pointer;
}
.icon-dropdown >>> .md-list {
  display: grid;
  grid-template-rows: repeat(3, auto);
  grid-template-columns: repeat(3, auto);
  grid-row-gap: 8px;
}
.icon-dropdown >>> .md-icon {
  cursor: pointer;
}
.icon-dropdown >>> .icon-img.selected {
  outline: 1px solid #d2dce6;
}
.icon-dropdown >>> .icon-img:hover {
  background: #d2dce6;
}
.icon-container {
  margin-top: 5px;
  display: flex;
  height: 32px;
  padding: 4px 4px 6px 10px;
  background: white;
  border: 1px solid #c4c4c4;
  border-radius: 5px;
}
.selected-icon {
  margin-right: 6px;
}
.icon-img {
  width: 24px;
  height: 24px;
  justify-self: center;
}
</style>